// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//
 export const environment = {
   production: false,
   authServiceUrl: 'https://auth.zikata.africa/auth',
   authRealm: 'client',
   authClientId: 'dashboard',
   authSuccessRedirectUrl: 'https://dashboard.zikata.africa',
   officerRoles: {
     ROLE_CLIENT: 'Client',
   },
   apiGatewayBaseUrl: 'https://backend.zikata.africa/api/v1',
   apiGatewayV2BaseUrl: 'https://backend.zikata.africa/api/v2',
   fbAccessToken: 'xx',
   phoneNumberId: 'xx',
 };

// export const environment = {
//   production: false,
//   authServiceUrl: 'https://auth.zikata.africa/auth',
//   authRealm: 'client',
//   authClientId: 'clients-portal',
//   authSuccessRedirectUrl: 'https://sms.zikata.africa',
//   officerRoles: {
//     ROLE_CLIENT: 'Client',
//   },
//   apiGatewayBaseUrl: 'https://api.zikata.africa/api/v1',
//   fbAccessToken: 'xx',
//   phoneNumberId: 'xx',
// };
